import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button/Button";
import { useCurrentPath } from "@faire/web--source/ui/hooks/useCurrentPath";
import React from "react";
import { useHistory } from "react-router-dom";
import { FAIRE_DIRECT_FOI } from "@faire/retailer-visitor-shared/components/App/AppModals/consts";
export var OpenFaireDirectFirstOrderIncentiveModalButton = function(chunks) {
    var history = useHistory();
    var currentPath = useCurrentPath();
    var openFaireDirectFirstOrderIncentiveModal = function() {
        history.push(currentPath.append({
            show_modal: FAIRE_DIRECT_FOI
        }).toString());
    };
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        onClick: openFaireDirectFirstOrderIncentiveModal,
        children: chunks
    });
};
